module.exports = __webpack_public_path__ + "img/document.621449f8.svg";